import React from 'react';

import { SVGProps } from './SVGProps';

const StepTwoIcon = ({ fill = 'none', width = '40', height = '40' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 42 47" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5692_9844)">
        <g clipPath="url(#clip1_5692_9844)">
          <path d="M26.709 41.1641H16.207" stroke={fill} strokeWidth="1.203" strokeMiterlimit="10" />
          <path
            d="M40.709 35.3508V27.6508C40.7093 27.4694 40.6583 27.2916 40.562 27.1378L35.4 18.9258C35.3161 18.7915 35.1993 18.6806 35.0608 18.6036C34.9223 18.5267 34.7665 18.4861 34.608 18.4858H26.644"
            stroke={fill}
            strokeWidth="1.212"
            strokeMiterlimit="10"
          />
          <path
            d="M30.103 21.949V27.136H36.068L32.901 22.236C32.8452 22.1495 32.7687 22.0783 32.6784 22.0289C32.5882 21.9795 32.487 21.9534 32.384 21.953L30.103 21.949Z"
            stroke={fill}
            strokeWidth="1.212"
            strokeMiterlimit="10"
          />
          <path
            d="M16.2762 41.9499C16.2638 41.0859 15.9963 40.245 15.5072 39.5327C15.0182 38.8204 14.3295 38.2685 13.5277 37.9465C12.726 37.6245 11.8469 37.5467 11.001 37.723C10.1552 37.8992 9.38028 38.3215 8.77377 38.9369C8.16727 39.5522 7.75621 40.3332 7.59229 41.1815C7.42836 42.0298 7.51888 42.9077 7.85246 43.7047C8.18605 44.5017 8.74782 45.1823 9.46713 45.661C10.1865 46.1397 11.0312 46.395 11.8952 46.3949C12.4748 46.3907 13.0478 46.2724 13.5816 46.0467C14.1154 45.8211 14.5995 45.4925 15.0064 45.0797C15.4132 44.667 15.7347 44.1781 15.9526 43.6411C16.1705 43.1041 16.2805 42.5294 16.2762 41.9499Z"
            stroke={fill}
            strokeWidth="1.212"
            strokeMiterlimit="10"
          />
          <path
            d="M35.4032 41.9499C35.3908 41.0859 35.1232 40.245 34.6342 39.5327C34.1452 38.8204 33.4565 38.2685 32.6547 37.9465C31.8529 37.6245 30.9738 37.5467 30.128 37.723C29.2821 37.8992 28.5072 38.3215 27.9007 38.9369C27.2942 39.5522 26.8832 40.3332 26.7192 41.1815C26.5553 42.0298 26.6458 42.9077 26.9794 43.7047C27.313 44.5017 27.8748 45.1823 28.5941 45.661C29.3134 46.1397 30.1582 46.395 31.0222 46.3949C31.6017 46.3907 32.1747 46.2724 32.7086 46.0467C33.2424 45.8211 33.7265 45.4925 34.1333 45.0797C34.5401 44.667 34.8617 44.1781 35.0796 43.6411C35.2974 43.1041 35.4074 42.5294 35.4032 41.9499Z"
            stroke={fill}
            strokeWidth="1.212"
            strokeMiterlimit="10"
          />
          <path
            d="M7.58295 41.1639H1.43296C1.3237 41.1631 1.21565 41.1408 1.11501 41.0983C1.01437 41.0557 0.923098 40.9938 0.846396 40.916C0.769695 40.8381 0.709073 40.746 0.667991 40.6447C0.626908 40.5435 0.606165 40.4351 0.606955 40.3259V34.9889C0.606165 34.8796 0.626908 34.7713 0.667991 34.67C0.709073 34.5688 0.769695 34.4766 0.846396 34.3988C0.923098 34.321 1.01437 34.259 1.11501 34.2165C1.21565 34.174 1.3237 34.1517 1.43296 34.1509H40.71V40.3259C40.7107 40.4351 40.69 40.5435 40.6489 40.6447C40.6079 40.746 40.5472 40.8381 40.4705 40.916C40.3938 40.9938 40.3025 41.0557 40.2019 41.0983C40.1013 41.1408 39.9932 41.1631 39.884 41.1639H35.334"
            stroke={fill}
            strokeWidth="1.212"
            strokeMiterlimit="10"
          />
          <path
            d="M26.644 31.2199V14.8579C26.6467 14.4736 26.4966 14.1038 26.2267 13.8301C25.9569 13.5563 25.5894 13.4009 25.205 13.3979H2.04401C1.65962 13.4009 1.29212 13.5563 1.02228 13.8301C0.752444 14.1038 0.602353 14.4736 0.605015 14.8579V31.2199"
            stroke={fill}
            strokeWidth="1.212"
            strokeMiterlimit="10"
          />
          <path
            d="M10.0098 29.4529L10.0178 28.4079L15.0178 23.8209C15.3829 23.5132 15.6752 23.1283 15.8738 22.6939C16.0152 22.3379 16.0872 21.9581 16.0858 21.5749C16.0917 21.1442 15.985 20.7193 15.776 20.3425C15.5671 19.9657 15.2633 19.6501 14.8948 19.4269C14.5266 19.2038 14.1032 19.0884 13.6728 19.0939C13.2283 19.0869 12.7911 19.2062 12.4118 19.4379C12.0497 19.6595 11.7497 19.9691 11.5398 20.3379C11.3276 20.7108 11.2201 21.134 11.2288 21.5629H10.0748C10.0648 20.92 10.2297 20.2865 10.5518 19.7299C10.861 19.1974 11.3066 18.7569 11.8428 18.4539C12.4064 18.1399 13.0427 17.9799 13.6878 17.9899C14.3131 17.9815 14.9291 18.1419 15.4709 18.454C16.0128 18.7662 16.4604 19.2188 16.7668 19.7639C17.0796 20.3171 17.2401 20.9435 17.2318 21.5789C17.2388 21.9969 17.1832 22.4135 17.0668 22.8149C16.9561 23.1732 16.7816 23.5086 16.5518 23.8049C16.286 24.1455 15.989 24.4605 15.6648 24.7459L11.2218 28.8169L11.0448 28.3489H17.2338V29.4489L10.0098 29.4529Z"
            fill={fill}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5692_9844">
          <rect width="41.316" height="47" fill="white" />
        </clipPath>
        <clipPath id="clip1_5692_9844">
          <rect width="41.316" height="34.208" fill="white" transform="translate(0 12.792)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default StepTwoIcon;
